import { render, staticRenderFns } from "./SchoolFirst.vue?vue&type=template&id=37708382&scoped=true&"
import script from "./SchoolFirst.vue?vue&type=script&lang=js&"
export * from "./SchoolFirst.vue?vue&type=script&lang=js&"
import style0 from "./SchoolFirst.vue?vue&type=style&index=0&id=37708382&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37708382",
  null
  
)

export default component.exports